import { render } from "./BlockOrderDetail.vue?vue&type=template&id=456dc826&scoped=true"
import script from "./BlockOrderDetail.vue?vue&type=script&lang=js"
export * from "./BlockOrderDetail.vue?vue&type=script&lang=js"

import "./BlockOrderDetail.vue?vue&type=style&index=0&id=456dc826&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456dc826"]])

export default __exports__